import React from 'react'
import Manager from '../../public/components/Manager'
import AssetAccDiv from './AssetAccDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '申请编号', field: 'Number', minWidth: 150, search: true, flex: 1 },
        { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
        { _text: '物料名称', field: '_MaterialNames', sortable: false, minWidth: 150, flex: 1 },
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
        { _text: '状态名称', field: 'StatusName', minWidth: 150, flex: 1, search: true },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <AssetAccDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} />)
    }
}

export default props => <Manager {...props} config={config} />